import './App.css';
import Homepage from './modules/homepage/Homepage';

function App() {
  return (
    <div className="light">
     <Homepage/>
    </div>
  );
}

export default App;
